export { default } from './ManageResume';
